import AdminFlashSales from '../admin/AdminFlashSales';
import EmployeeLayout from './EmployeeLayout';

export default function EmployeeFlashSales() {
  return <AdminFlashSales Layout={EmployeeLayout} />;
}
